import { render, staticRenderFns } from "./Reload.vue?vue&type=template&id=7201b52a"
import script from "./Reload.vue?vue&type=script&lang=ts"
export * from "./Reload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports